/** 個人メアドでのログインが組織ポリシーで拒否された場合の 403 エラー（code: PERSONAL_EMAIL_LOGIN_DENIED）。 */
export class PersonalEmailLoginDeniedError extends Error {
  constructor(readonly displayMessage?: string) {
    super('Personal email login denied');
    this.name = 'PersonalEmailLoginDeniedError';
    Object.setPrototypeOf(this, PersonalEmailLoginDeniedError.prototype);
  }
}